// extracted by mini-css-extract-plugin
export default {"button":"Zn-z","reviewSort":"_n-z"};